import request from '@/utils/request';
import { parseStrEmpty } from "@/utils/fs";

// 登录方法
export function login(username, password) {
    const data = {
        username,
        password,
    }
    
    return request({
        url: '/pa/xcx/paxcxpro/admin/employee/login',
        headers: {
            isToken: false
        },
        method: 'post',
        data: data
    })
}
// 退出登录
export function logout() {
    return request({
        url: '/pa/xcx/paxcxpro/admin/employee/logout',
        method: 'post'
    })
}
// 获取账号角色授权信息
export function getUserInfo(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/employee/getInfo',
        method: 'post',
        data: data
    })
}
/**
 * 分页查询账号列表
 * @param {*} data 
 * @returns 
 */
export function pageUser(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/employee/page',
        method: 'post',
        data:data
    })
}
/**
 * 新增账号
 * @param {*} data 
 * @returns 
 */
export function addUser(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/employee',
        method: 'post',
        data: data
    })
}
/**
 * 查询授权角色
 * @param {*} employeeId 
 * @returns 
 */
export function getAuthRole(employeeId) {
    return request({
      url: '/pa/xcx/paxcxpro/admin/employee/authRole/' + employeeId,
      method: 'get'
    })
}
/**
 * 保存授权角色
 * @param {*} data 
 * @returns 
 */
export function updateAuthRole(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/employee/authRole',
        method: 'post',
        data: data
    })
}
/**
 * 根据ID获取账号信息
 * @param {*} id 
 * @returns 
 */
export function getUser(id) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/employee/detail',
        method: 'post',
        data: id
    })
}
/**
 * 修改账号信息
 * @param {*} data 
 * @returns 
 */
export function updateUser(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/employee/update',
        method: 'post',
        data: data
    })
}
/**
 * 修改密码
 * @param {*} data 
 * @returns 
 */
export function updateUserPwd(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/employee/editPassword',
        method: 'post',
        data: data
    })
}
/**
 * 启用 、 禁用 账号
 * @param {*} data 
 * @returns 
 */
export function changeUserStatus(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/employee/status',
        method: 'post',
        data: data
    })
}
/**
 * 上传头像
 * @param {*} data 
 * @returns 
 */
export function uploadAvatar(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/common/upload',
        method: 'post',
        headers: {'Content-Type': 'multipart/form-data'},
        data: data
    })
}